import { environment } from '@base/environments/environment';
import { RenditionsService } from '../../services/renditions/renditions.service';
import { ReservasListService } from '../../services/renditions/reservas-list.service';
import {
  CommissionSummary,
  StatisticsComputationMode,
} from './commission-summary.model';
import { buildStatisticsSummary } from './rendition-statistics.calculation';
import { InvoiceRendition } from './invoices.model';
import { Constants } from '../constants';

export const NODE_DO = Constants.TENANT_ID_DO;

export const NODE = environment.node;
export class AgentTypesArray {
  static agentTypesArray: Record<string, string> = {
    BROKER_MANAGER: 'Broker Manager',
    SENIOR: 'Senior',
    JUNIOR: 'Junior',
    BROKER_OWNER: 'Broker Owner',
    TEAM_JUNIOR: 'TEAM_JUNIOR',
    ALTO: 'ALTO',
    RAPP: 'RAPP',
    PURO: 'PURO',
  };
}
export class RenditionModelBE {
  accesstoken: null = null;
  agencyAmountCommissionARS: number = 0;
  agencyAmountCommissionUSD: number = 0;
  agencyId: number = 0;
  agencyName: null = null;
  agentBillings: AgentBilling[] = [];
  agentPayments: AgentPayment[] = [];
  amountByRental: boolean = false;
  billingIVAAgentARS: number = 0;
  billingIVAAgentUSD: number = 0;
  billingSubTotalARS: number = 0;
  billingSubTotalIVAARS: number = 0;
  billingSubTotalIVAUSD: number = 0;
  billingSubTotalUSD: number = 0;
  billingTotalARS: number = 0;
  billingTotalUSD: number = 0;
  billings: Billing[] = [];
  clientContact: ClientContact = new ClientContact();
  contractTime: number = 0;
  contractTimeType: number = 0;
  contractTimeTypeTxt: string = '';
  createdBy: null = null;
  createdDate: null = null;
  createdDateTxt: null = null;
  credit: boolean = false;
  deduction_amount_ars_c: number = 0;
  deduction_amount_ars_v: number = 0;
  deduction_amount_usd_c: number = 0;
  deduction_amount_usd_v: number = 0;
  exchangeRate: number = 0;
  exclusivityType: number = 0;
  exclusivityTypeTxt: string = '';
  grossAgencyComissionARS: number = 0;
  grossAgencyComissionARSWithoutReferredDeduction: number = 0;
  grossAgencyComissionPercentage: number = 0;
  grossAgencyComissionPercentageWithoutReferredDeduction: number = 0;
  grossAgencyComissionUSD: number = 0;
  grossAgencyComissionUSDWithoutReferredDeduction: number = 0;
  grossComissionARS: number = 0;
  grossComissionPercentage: number = 0;
  grossComissionUSD: number = 0;
  id: number = 0;
  jurisdictionDeduction: Deduction = new Deduction();
  jurisdictionId: number = 0;
  jurisdictionTxt: string = '';
  mlsId: string = '';
  notes: string = '';
  operationType: number = 0;
  operationTypeTxt: string = '';
  organizationCommission: OrganizationCommission = new OrganizationCommission();
  organization_name_c: null = null;
  organization_name_v: null = null;
  originalAgentPayments: AgentPayment[] = [];
  originalsBillings: Billing[] = [];
  otherDeductions: any[] = [];
  otherRealEstate: OtherRealEstate | null = null;
  overbillingARS: number = 0;
  overbillingUSD: number = 0;
  propertyAddress: string = '';
  propertyType: number = 0;
  propertyTypeTxt: string = '';
  purchaseDeduction: Deduction = new Deduction();
  purchaseJurisdictionDeduction: Deduction = new Deduction();
  purchaseOrganizationAmountCommissionARS: number = 0;
  purchaseOrganizationAmountCommissionUSD: number = 0;
  quotaNumber?: number | null;
  saleJurisdictionDeduction: Deduction = new Deduction();
  purchaseOrganizationName: null = null;
  purchaseRelationshipPercentage: number = 0;
  referredCommissions: ReferredCommission[] = [];
  referredDeductions: ReferredDeduction[] = [];
  relationFiftyFifty: boolean = false;
  remoteHost: null = null;
  renditionBillingVOList: null = null;
  renditionDate: string = '';
  renditionId: number = 0;
  renditionIdEdit: null = null;
  renditionType: number = 0;
  renditionTypeTxt: null = null;
  reservationId: number = 0;
  reservationNotes: string = '';
  saleDeduction: Deduction = new Deduction();
  saleOrganizationAmountCommissionARS: number = 0;
  saleOrganizationAmountCommissionUSD: number = 0;
  saleOrganizationName: null = null;
  saleRelationshipPercentage: number = 0;
  salesJurisdictionDeduction: Deduction = new Deduction();
  sharedAgencyId: number = 0;
  sharedAgencyName: string = '';
  sharedBy: number = 0;
  sharedByTxt: string = '';
  teamLeaderCommissions: TeamLeaderCommission[] | null = null;
  teamLeaderDeductions: TeamLeaderDeduction[] | null = null;
  tipoCajaDestinoEgresoSinComprobante: number = 0;
  tipoCajaDestinoEgresoSinComprobanteLabel: null = null;
  tipoCajaDestinoIngresoSinComprobante: number = 0;
  tipoCajaDestinoIngresoSinComprobanteLabel: null = null;
  totalAmountOperationARS: number = 0;
  totalAmountOperationUSD: number = 0;
  updatedBy: null = null;
  updatedDate: null = null;
  updatedDateTxt: null = null;
  userId: null = null;
  newModule: boolean = false;
  bank: number | null = null;
  bankText?: string;
  qrId: string | null = '';
  entrepreneurshipId: string | null = '';
  cobrokerTeamLeaders: CobrokerTeamLeader[] | undefined;
  cobrokersCommissions: CobrokerCommission[] | undefined;
  royaltyAmount?: number | null | undefined;
  royaltyPercentage?: number | null | undefined;
  pendingCommissions?: boolean | undefined;

  constructor(
    private readonly renditionsService: RenditionsService,
    private readonly getReservasService: ReservasListService,
    data?: any,
  ) {
    this.accesstoken = data?.accesstoken ?? null;
    this.agencyAmountCommissionARS = data?.agencyAmountCommissionARS ?? 0;
    this.agencyAmountCommissionUSD = data?.agencyAmountCommissionUSD ?? 0;
    this.agencyId = data?.agencyId ?? 0;
    this.agencyName = data?.agencyName ?? '';
    this.agentBillings = data?.agentBillings ?? [];
    this.agentPayments = data?.agentPayments ?? [];
    this.amountByRental = data?.amountByRental ?? false;
    this.billingIVAAgentARS = data?.billingIVAAgentARS ?? 0;
    this.billingIVAAgentUSD = data?.billingIVAAgentUSD ?? 0;
    this.billingSubTotalARS = data?.billingSubTotalARS ?? 0;
    this.billingSubTotalIVAARS = data?.billingSubTotalIVAARS ?? 0;
    this.billingSubTotalIVAUSD = data?.billingSubTotalIVAUSD ?? 0;
    this.billingSubTotalUSD = data?.billingSubTotalUSD ?? 0;
    this.billingTotalARS = data?.billingTotalARS ?? 0;
    this.billingTotalUSD = data?.billingTotalUSD ?? 0;
    this.billings = data?.billings ?? [];
    this.clientContact = data?.clientContact ?? [];
    this.contractTime = data?.contractTime ?? 0;
    this.contractTimeType = data?.contractTimeType ?? 0;
    this.contractTimeTypeTxt = data?.contractTimeTypeTxt ?? '';
    this.createdBy = data?.createdBy ?? null;
    this.createdDate = data?.createdDate ?? null;
    this.createdDateTxt = data?.createdDateTxt ?? null;
    this.credit = data?.credit ?? false;
    this.deduction_amount_ars_c = data?.deduction_amount_ars_c ?? 0;
    this.deduction_amount_ars_v = data?.deduction_amount_ars_v ?? 0;
    this.deduction_amount_usd_c = data?.deduction_amount_usd_c ?? 0;
    this.deduction_amount_usd_v = data?.deduction_amount_usd_v ?? 0;
    this.exchangeRate = data?.exchangeRate ?? 0;
    this.exclusivityType = data?.exclusivityType ?? 2;
    this.exclusivityTypeTxt = data?.exclusivityTypeTxt ?? '';
    this.grossAgencyComissionARS = data?.grossAgencyComissionARS ?? 0;
    this.grossAgencyComissionARSWithoutReferredDeduction =
      data?.grossAgencyComissionARSWithoutReferredDeduction ?? 0;
    this.grossAgencyComissionPercentage =
      data?.grossAgencyComissionPercentage ?? 0;
    this.grossAgencyComissionPercentageWithoutReferredDeduction =
      data?.grossAgencyComissionPercentageWithoutReferredDeduction ?? 0;
    this.grossAgencyComissionUSD = data?.grossAgencyComissionUSD ?? 0;
    this.grossAgencyComissionUSDWithoutReferredDeduction =
      data?.grossAgencyComissionUSDWithoutReferredDeduction ?? 0;
    this.grossComissionARS = data?.grossComissionARS ?? 0;
    this.grossComissionPercentage = data?.grossComissionPercentage ?? 0;
    this.grossComissionUSD = data?.grossComissionUSD ?? 0;
    this.id = data?.id ?? 0;
    this.jurisdictionDeduction = data?.jurisdictionDeduction ?? [];
    this.jurisdictionId = data?.jurisdictionId ?? 0;
    this.jurisdictionTxt = data?.jurisdictionTxt ?? '';
    this.mlsId = data?.mlsId ?? '';
    this.notes = data?.notes ?? '';
    this.operationType = data?.operationType ?? 0;
    this.operationTypeTxt = data?.operationTypeTxt ?? '';
    this.organizationCommission = data?.organizationCommission ?? '';
    this.organization_name_c = data?.organization_name_c ?? null;
    this.organization_name_v = data?.organization_name_v ?? null;
    this.originalAgentPayments = data?.originalAgentPayments ?? [];
    this.originalsBillings = data?.originalsBillings ?? [];
    this.otherDeductions = data?.otherDeductions ?? [];
    this.otherRealEstate = data?.otherRealEstate ?? null;
    this.overbillingARS = data?.overbillingARS ?? 0;
    this.overbillingUSD = data?.overbillingUSD ?? 0;
    this.propertyAddress = data?.propertyAddress ?? '';
    this.propertyType = data?.propertyType ?? 0;
    this.propertyTypeTxt = data?.propertyTypeTxt ?? '';
    this.purchaseDeduction = data?.purchaseDeduction ?? [];
    this.purchaseJurisdictionDeduction =
      data?.purchaseJurisdictionDeduction ?? [];
    this.saleJurisdictionDeduction = data?.saleJurisdictionDeduction ?? [];
    this.purchaseOrganizationAmountCommissionARS =
      data?.purchaseOrganizationAmountCommissionARS ?? 0;
    this.purchaseOrganizationAmountCommissionUSD =
      data?.purchaseOrganizationAmountCommissionUSD ?? 0;
    this.purchaseOrganizationName = data?.purchaseOrganizationName ?? '';
    this.purchaseRelationshipPercentage =
      data?.purchaseRelationshipPercentage ?? 0;
    this.quotaNumber = data?.quotaNumber;
    this.referredCommissions = data?.referredCommissions ?? [];
    this.referredDeductions = data?.referredDeductions ?? [];
    this.relationFiftyFifty = data?.relationFiftyFifty ?? false;
    this.remoteHost = data?.remoteHost ?? null;
    this.renditionBillingVOList = data?.renditionBillingVOList ?? null;
    this.renditionDate = data?.renditionDate ?? '';
    this.renditionId = data?.renditionId ?? 0;
    this.renditionIdEdit = data?.renditionIdEdit ?? null;
    this.renditionType = data?.renditionType ?? 0;
    this.renditionTypeTxt = data?.renditionTypeTxt ?? '';
    this.reservationId = data?.reservationId ?? 0;
    this.reservationNotes = data?.reservationNotes ?? '';
    this.saleDeduction = data?.saleDeduction ?? [];
    this.saleOrganizationAmountCommissionARS =
      data?.saleOrganizationAmountCommissionARS ?? 0;
    this.saleOrganizationAmountCommissionUSD =
      data?.saleOrganizationAmountCommissionUSD ?? 0;
    this.saleOrganizationName = data?.saleOrganizationName ?? null;
    this.saleRelationshipPercentage = data?.saleRelationshipPercentage ?? 0;
    this.salesJurisdictionDeduction = data?.salesJurisdictionDeduction ?? 0;
    this.sharedAgencyId = data?.sharedAgencyId ?? 0;
    this.sharedAgencyName = data?.sharedAgencyName ?? '';
    this.sharedBy = data?.sharedBy ?? 0;
    this.sharedByTxt = data?.sharedByTxt ?? '';
    this.tipoCajaDestinoEgresoSinComprobante =
      data?.tipoCajaDestinoEgresoSinComprobante ?? 0;
    this.tipoCajaDestinoEgresoSinComprobanteLabel =
      data?.tipoCajaDestinoEgresoSinComprobanteLabel ?? null;
    this.tipoCajaDestinoIngresoSinComprobante =
      data?.tipoCajaDestinoIngresoSinComprobante ?? 0;
    this.tipoCajaDestinoIngresoSinComprobanteLabel =
      data?.tipoCajaDestinoIngresoSinComprobanteLabel ?? null;
    this.totalAmountOperationARS = data?.totalAmountOperationARS ?? 0;
    this.totalAmountOperationUSD = data?.totalAmountOperationUSD ?? 0;
    this.updatedBy = data?.updatedBy ?? null;
    this.updatedDate = data?.updatedDate ?? null;
    this.updatedDateTxt = data?.updatedDateTxt ?? null;
    this.userId = data?.userId ?? null;
    this.newModule = data?.newModule ?? false;
    this.bank = data?.bank ?? null;
    this.bankText = data?.bankText ?? undefined;
    this.qrId = '';
    this.entrepreneurshipId = '';
    this.teamLeaderCommissions = data?.teamLeaderCommissions ?? null;
    this.teamLeaderDeductions = data?.teamLeaderDeductions ?? null;
    this.cobrokerTeamLeaders = data?.cobrokerTeamLeaders ?? [];
    this.cobrokersCommissions = data?.cobrokersCommissions ?? [];
  }

  async getAgentList(agencyId: string): Promise<Agent[]> {
    let array: Agent[] = [];
    const URL = agencyId + '/agents';
    await this.renditionsService.get(URL).then((response: any) => {
      if (response?.data?.agents) {
        array = [...response.data.agents];
      }
    });
    return array;
  }

  async getJurisdictions(agencyId: string) {
    let array: Jurisdiction[] = [];
    const URL = agencyId + '/jurisdictions';
    await this.getReservasService.get(URL).then((response: any) => {
      if (response?.data?.jurisdictions) {
        array = [...response.data.jurisdictions];
      }
    });
    return array;
  }

  /**
   * Modo con el que se guardo la rendicion: 1 = Split Member/Leader, 0 = 100% Team Member.
   * Sale de las deducciones de Team Leader, igual que en el formulario.
   */
  private getStatisticsComputationMode(): StatisticsComputationMode {
    const DEDUCTIONS = this.teamLeaderDeductions ?? [];
    // Si ninguna punta tiene Team Leader, el modo quedo guardado en el Team
    // Leader del co-broker, que se envia con el mismo flag
    const SOURCE =
      DEDUCTIONS.find((e) => e.deductionType === 1) ??
      DEDUCTIONS.find((e) => e.deductionType === 2) ??
      this.cobrokerTeamLeaders?.[0];

    return SOURCE?.checkTeamLeader === 0 ? 0 : 1;
  }

  async formatForCheckout(
    agencyId: string,
    agencyName: string,
    officeList: { id: number; name: string }[],
  ): Promise<CommissionSummary> {
    const NODE = environment.node;
    const NODE_DO = Constants.TENANT_ID_DO;
    const IS_NODE_DO = NODE === NODE_DO;

    let isSellerMyOffice = false;
    let isBuyerMyOffice = false;
    let commissionSummary: CommissionSummary = new CommissionSummary();
    // Precio de cierre USD
    commissionSummary.closedPrice.usd = this.totalAmountOperationUSD ?? 0;
    // Precio de cierre Local
    commissionSummary.closedPrice.local = this.totalAmountOperationARS ?? 0;

    // Comision Bruta porcentaje
    commissionSummary.rawCommission.percentage = this.grossComissionPercentage;
    // Comision Bruta USD
    commissionSummary.rawCommission.usd = this.grossComissionUSD;
    // Comision Bruta Local
    commissionSummary.rawCommission.local = this.grossComissionARS;

    const JURISDICION_ARRAY = await this.getJurisdictions(agencyId);
    const JURISDICION = JURISDICION_ARRAY.find(
      (e: Jurisdiction) => e.id == this.jurisdictionId,
    );

    /////////////////////////////////////////////
    ///////////// Referido a cobrar /////////////
    /////////////////////////////////////////////

    if (this.renditionType == 2 || this.renditionType == 5) {
      commissionSummary.referred.isReferred = true;

      commissionSummary.referred.isSeller =
        this.purchaseRelationshipPercentage == 100;
      commissionSummary.referred.name = commissionSummary.referred.isSeller
        ? this.organizationCommission.purchaseOrganizationName
        : this.organizationCommission.saleOrganizationName;

      if (this.otherDeductions?.length > 0) {
        commissionSummary.referred.manualDeduction.name =
          this.otherDeductions[0].description;
        commissionSummary.referred.manualDeduction.usd =
          this.otherDeductions[0].amountUSD;
        commissionSummary.referred.manualDeduction.local =
          this.otherDeductions[0].amountARS;
      }

      commissionSummary.referidoACobrarCalculation();

      commissionSummary.referred.deduction.percentage = commissionSummary
        .referred.isSeller
        ? this.purchaseDeduction.deductionPercentage
        : this.saleDeduction.deductionPercentage;
      commissionSummary.referred.deduction.usd = commissionSummary.referred
        .isSeller
        ? this.purchaseDeduction.deductionAmountUSD
        : this.saleDeduction.deductionAmountUSD;
      commissionSummary.referred.deduction.local = commissionSummary.referred
        .isSeller
        ? this.purchaseDeduction.deductionAmountARS
        : this.saleDeduction.deductionAmountARS;

      commissionSummary.referred.type.name = commissionSummary.referred.isSeller
        ? this.organizationCommission.purchaseOrganizationAgentType
        : this.organizationCommission.saleOrganizationAgentType;
      if (
        this.organizationCommission.purchaseOrganizationTeamId ||
        this.organizationCommission.saleOrganizationTeamId
      ) {
        commissionSummary.referred.type.name = 'TEAM_JUNIOR';
      }

      // Deduccion vendedor por tipo de agente
      commissionSummary.referred.type.usd =
        (commissionSummary.referred.secondSubtotal.usd ?? 0) *
        ((100 -
          CommissionSummary.dataArray[commissionSummary.referred.type.name]) /
          100);
      commissionSummary.referred.type.local =
        (commissionSummary.referred.secondSubtotal.local ?? 0) *
        ((100 -
          CommissionSummary.dataArray[commissionSummary.referred.type.name]) /
          100);

      commissionSummary.referidoACobrarCalculation();
    } else {
      /////////////////////////////////////////////
      ///////////// Punta Vendedora ///////////////
      /////////////////////////////////////////////

      // Tengo ambas puntas
      if (
        (this.sharedBy == 1 &&
          (this.sharedAgencyId == 0 || !this.sharedAgencyId)) ||
        (this.sharedBy == 2 && this.sharedAgencyId == Number(agencyId))
      ) {
        commissionSummary.seller.officeId = null;
        commissionSummary.seller.otherRealEstateName = null;
        commissionSummary.buyer.officeId = null;
        commissionSummary.buyer.otherRealEstateName = null;
        commissionSummary.seller.agent.office = agencyName;
        commissionSummary.buyer.agent.office = agencyName;

        isSellerMyOffice = true;
        isBuyerMyOffice = true;
      } else if (this.sharedBy == 2) {
        // la punta vendedora es otro remax
        if (this.organizationCommission.purchaseOrganizationId == 0) {
          commissionSummary.seller.officeId = this.sharedAgencyId;
          commissionSummary.seller.otherRealEstateName = null;
          isBuyerMyOffice = true;
          commissionSummary.seller.agent.office = this.sharedAgencyName;
          commissionSummary.buyer.agent.office = agencyName;
        }
        // la punta compradora es otro remax
        if (this.organizationCommission.saleOrganizationId == 0) {
          commissionSummary.buyer.officeId = this.sharedAgencyId;
          commissionSummary.buyer.otherRealEstateName = null;
          isSellerMyOffice = true;
          isBuyerMyOffice = false;
          commissionSummary.buyer.agent.office = this.sharedAgencyName;
          commissionSummary.seller.agent.office = agencyName;
        }
      } else {
        // la punta vendedora es otra inmobiliaria

        if (this.organizationCommission.purchaseOrganizationId == 0) {
          commissionSummary.seller.officeId = null;
          commissionSummary.seller.otherRealEstateName = this.otherRealEstate
            ? this.otherRealEstate.name
            : this.sharedAgencyName;

          isBuyerMyOffice = true;
          commissionSummary.buyer.agent.office = agencyName;
        }
        // la punta compradora es otra inmobiliaria

        if (this.organizationCommission.saleOrganizationId == 0) {
          commissionSummary.buyer.officeId = null;
          commissionSummary.buyer.otherRealEstateName = this.otherRealEstate
            ? this.otherRealEstate.name
            : this.sharedAgencyName;
          isSellerMyOffice = true;
          isBuyerMyOffice = false;
          commissionSummary.seller.agent.office = agencyName;
        }
      }

      // Relacion
      commissionSummary.seller.relation = this.purchaseRelationshipPercentage;

      // USD
      commissionSummary.seller.usd =
        this.grossComissionUSD * (commissionSummary.seller.relation / 100);

      // Local
      commissionSummary.seller.local =
        this.grossComissionARS * (commissionSummary.seller.relation / 100);

      if (NODE === NODE_DO) {
        const TOTAL_COBROKER_USD = this.cobrokersCommissions?.reduce(
          (sum, cobroker) => {
            return sum + cobroker.grossAmountUsd;
          },
          0,
        );

        commissionSummary.seller.usd =
          commissionSummary.seller.usd - (TOTAL_COBROKER_USD ?? 0);

        const TOTAL_COBROKER_LOCAL = this.cobrokersCommissions?.reduce(
          (sum, cobroker) => {
            return sum + cobroker.grossAmountArs;
          },
          0,
        );

        commissionSummary.seller.local =
          commissionSummary.seller.local - (TOTAL_COBROKER_LOCAL ?? 0);
      }

      // Porcentaje
      commissionSummary.seller.percentage =
        this.organizationCommission.purchaseCommissionPercentage;

      commissionSummary.seller.agent.name =
        this.organizationCommission.purchaseOrganizationName;

      // Jurisdiccion agente
      commissionSummary.seller.agent.deduction.percentage =
        this.purchaseDeduction.deductionPercentage;

      commissionSummary.seller.agent.deduction.usd =
        this.purchaseDeduction.deductionAmountUSD;

      commissionSummary.seller.agent.deduction.local =
        this.purchaseDeduction.deductionAmountARS;

      // Deduccion Manual vendedor

      const sellerManualDeduction = this.otherDeductions.find(
        (e: OtherDeduction) => e.type == 1,
      );
      if (sellerManualDeduction) {
        commissionSummary.seller.agent.manualDeduction.name =
          sellerManualDeduction.description;
        commissionSummary.seller.agent.manualDeduction.usd =
          sellerManualDeduction.amountUSD;
        commissionSummary.seller.agent.manualDeduction.local =
          sellerManualDeduction.amountARS;
      }

      // Referido vendedor
      const sellerReferredCommission = this.referredCommissions.find(
        (e: ReferredCommission) => e.type == 1,
      );
      // Referido vendedor
      const sellerReferredDeduction = this.referredDeductions.find(
        (e: ReferredDeduction) => e.typePayment == 1,
      );

      if (sellerReferredDeduction && sellerReferredCommission) {
        commissionSummary.seller.referred.name =
          sellerReferredDeduction.organizationName ?? '';
        commissionSummary.seller.referred.rawCommission.percentage =
          sellerReferredDeduction.deductionPercentage;
        commissionSummary.seller.referred.rawCommission.usd =
          sellerReferredDeduction.deductionAmountUSD;
        commissionSummary.seller.referred.rawCommission.local =
          sellerReferredDeduction.deductionAmountARS;
        if (sellerReferredDeduction.organizationId) {
          commissionSummary.seller.referred.name =
            sellerReferredDeduction.organizationName ?? '';

          if (sellerReferredDeduction.organizationId != 0) {
            if (IS_NODE_DO) {
              commissionSummary.seller.referred.type.name =
                sellerReferredCommission.organizationAgentType ?? '';
              commissionSummary.seller.referred.type.original =
                AgentTypesArray.agentTypesArray[
                  sellerReferredCommission.organizationAgentLevelType ?? ''
                ] ?? '';
            } else {
              commissionSummary.seller.referred.type.name =
                sellerReferredCommission.organizationAgentType;
              if (
                sellerReferredCommission.organizationId ==
                  sellerReferredCommission.organizationTeamLeaderId ||
                sellerReferredCommission.organizationTeamId
              ) {
                commissionSummary.seller.referred.type.name = 'TEAM_JUNIOR';
              }
            }

            commissionSummary.seller.referred.type.usd =
              (commissionSummary.seller.referred.rawCommission.usd ?? 0) *
              ((100 -
                CommissionSummary.dataArray[
                  commissionSummary.seller.referred.type.name
                ]) /
                100);
            commissionSummary.seller.referred.type.local =
              (commissionSummary.seller.referred.rawCommission.local ?? 0) *
              ((100 -
                CommissionSummary.dataArray[
                  commissionSummary.seller.referred.type.name
                ]) /
                100);
            commissionSummary.seller.referred.netCommission.usd =
              sellerReferredCommission.commissionUSD;

            commissionSummary.seller.referred.netCommission.local =
              sellerReferredCommission.commissionARS;

            switch (commissionSummary.seller.referred.type.name) {
              case 'ALTO':
                commissionSummary.seller.referred.agentDeduction.percentage =
                  JURISDICION?.altoDeductionPercentage ?? 0;
                break;
              case 'PURO':
                commissionSummary.seller.referred.agentDeduction.percentage =
                  JURISDICION?.puroDeductionPercentage ?? 0;
                break;
              case 'TEAM_JUNIOR':
                commissionSummary.seller.referred.agentDeduction.percentage =
                  JURISDICION?.teamDeductionPercentage ?? 0;
                break;
            }

            commissionSummary.seller.referred.agentDeduction.local =
              commissionSummary.seller.referred.rawCommission.local *
              (commissionSummary.seller.referred.agentDeduction.percentage /
                100);
            commissionSummary.seller.referred.agentDeduction.usd =
              commissionSummary.seller.referred.rawCommission.usd *
              (commissionSummary.seller.referred.agentDeduction.percentage /
                100);
          }
        } else if (
          sellerReferredDeduction.agencyId &&
          (sellerReferredDeduction.organizationType == 1 ||
            sellerReferredDeduction.organizationType == 5)
        ) {
          const office = officeList.find(
            (e: { id: number; name: string }) =>
              e.id == sellerReferredDeduction.agencyId,
          );
          commissionSummary.seller.referred.officeId = office
            ? office.name.toUpperCase()
            : '-';
        } else {
          commissionSummary.seller.referred.officeId = '(Otra Inmobiliaria)';
        }
      }

      commissionSummary.sellerReferredCalculation();

      if (NODE === NODE_DO) {
        if (this.cobrokersCommissions && this.cobrokersCommissions.length > 0) {
          for (const coBroker of this.cobrokersCommissions) {
            let name = '';
            let office = '';
            let officeId: number | null = coBroker.agencyId ?? null;
            let otherRealEstateName = null;

            const OFFICE = officeList.find(
              (e: { id: number; name: string }) => e.id === officeId,
            );

            switch (coBroker.organizationType) {
              case 5:
                name = coBroker.organizationNameOtherRemax ?? '';
                office = OFFICE?.name ?? '';
                break;
              case 4:
                otherRealEstateName = coBroker.organizationName ?? null;
                break;
              case 2:
                name = coBroker.organizationName ?? '';
                office = agencyName;
                officeId = null;
                break;
            }

            let teamLeader = {
              name: '',
              rawCommission: { usd: 0, local: 0 },
              type: {
                name: '',
                usd: 0,
                local: 0,
                original: '',
              },
              agentDeduction: { percentage: 0, usd: 0, local: 0 },
              netCommission: { usd: 0, local: 0 },
            };

            // External cobrokers never have a team leader
            const IS_OWN_OFFICE_COBROKER = coBroker.organizationType === 2;

            const FIND_TEAM_LEADER = IS_OWN_OFFICE_COBROKER
              ? this.cobrokerTeamLeaders?.find(
                  (e: CobrokerTeamLeader) =>
                    e.juniorOrganizationId === coBroker.organizationId,
                )
              : undefined;

            if (FIND_TEAM_LEADER) {
              teamLeader.name = FIND_TEAM_LEADER.organizationName;
              teamLeader.rawCommission.usd =
                FIND_TEAM_LEADER.grossDeductionAmountUsd;
              teamLeader.rawCommission.local =
                FIND_TEAM_LEADER.grossDeductionAmountArs;

              teamLeader.netCommission.usd =
                FIND_TEAM_LEADER.netDeductionAmountUsd;
              teamLeader.netCommission.local =
                FIND_TEAM_LEADER.netDeductionAmountArs;
              teamLeader.type.name = FIND_TEAM_LEADER.teamLeaderType;
              teamLeader.type.original =
                AgentTypesArray.agentTypesArray[
                  FIND_TEAM_LEADER.teamLeaderLevelType
                ] ?? '';

              // The office deduction base is the whole gross commission assigned
              // to the associated cobroker, not the team leader split
              const OFFICE_DEDUCTION_FACTOR =
                (100 -
                  CommissionSummary.dataArray[
                    FIND_TEAM_LEADER.teamLeaderType
                  ]) /
                100;
              const HAS_VALID_FACTOR = !isNaN(OFFICE_DEDUCTION_FACTOR);

              teamLeader.type.usd = HAS_VALID_FACTOR
                ? coBroker.grossAmountUsd * OFFICE_DEDUCTION_FACTOR
                : 0;
              teamLeader.type.local = HAS_VALID_FACTOR
                ? coBroker.grossAmountArs * OFFICE_DEDUCTION_FACTOR
                : 0;
            }

            const RAW_COMMISSION = {
              usd: coBroker.grossAmountUsd,
              local: coBroker.grossAmountArs,
            };

            const NET_COMMISSION = {
              usd: coBroker.netAmountUsd,
              local: coBroker.netAmountArs,
            };

            const TYPE = {
              name: coBroker.agentType ?? '',
              usd:
                coBroker.grossAmountUsd *
                ((100 - CommissionSummary.dataArray[coBroker.agentType]) / 100),
              local:
                coBroker.grossAmountArs *
                ((100 - CommissionSummary.dataArray[coBroker.agentType]) / 100),
              original:
                AgentTypesArray.agentTypesArray[coBroker.agentLevelType] ?? '',
            };

            const AGENT_DEDUCTION = {
              percentage: 0,
              usd: 0,
              local: 0,
            };

            const OBJECT_COBROKER = {
              id: coBroker.organizationIdOtherRemax ?? coBroker.organizationId,
              name:
                coBroker.organizationNameOtherRemax ??
                coBroker.organizationName,
              office: office,
              officeId: officeId,
              otherRealEstateName: otherRealEstateName,
              rawCommission: RAW_COMMISSION,
              type: TYPE,
              agentDeduction: AGENT_DEDUCTION,
              netCommission: NET_COMMISSION,
              teamLeader: teamLeader,
            };
            commissionSummary.cobrokers.push(OBJECT_COBROKER);
          }
        }
      }

      // Team Leader
      if (this.teamLeaderCommissions && this.teamLeaderCommissions.length > 0) {
        const SELLER_TEAM_LEADER_COMMISSION = this.teamLeaderCommissions.find(
          (e: TeamLeaderCommission) => e.type === 1,
        );
        if (SELLER_TEAM_LEADER_COMMISSION) {
          commissionSummary.seller.teamLeader.name =
            SELLER_TEAM_LEADER_COMMISSION.organizationName;
          commissionSummary.seller.teamLeader.netCommission.usd =
            SELLER_TEAM_LEADER_COMMISSION.commissionUSD;
          commissionSummary.seller.teamLeader.netCommission.local =
            SELLER_TEAM_LEADER_COMMISSION.commissionARS;
        }
      }

      if (this.teamLeaderDeductions && this.teamLeaderDeductions.length > 0) {
        const SELLER_TEAM_LEADER_DEDUCTIONS = this.teamLeaderDeductions.find(
          (e: TeamLeaderDeduction) => e.deductionType === 1,
        );
        if (SELLER_TEAM_LEADER_DEDUCTIONS) {
          commissionSummary.seller.teamLeader.rawCommission.usd =
            SELLER_TEAM_LEADER_DEDUCTIONS.deductionAmountUsd;
          commissionSummary.seller.teamLeader.rawCommission.local =
            SELLER_TEAM_LEADER_DEDUCTIONS.deductionAmountArs;

          if (NODE === NODE_DO) {
            commissionSummary.seller.teamLeader.type.name =
              SELLER_TEAM_LEADER_DEDUCTIONS.teamLeaderType ?? '';

            commissionSummary.seller.teamLeader.type.original =
              AgentTypesArray.agentTypesArray[
                SELLER_TEAM_LEADER_DEDUCTIONS.teamLeaderLevelType ?? ''
              ] ?? '';

            commissionSummary.seller.teamLeader.type.usd =
              (commissionSummary.seller.usd ?? 0) *
              ((100 -
                CommissionSummary.dataArray[
                  commissionSummary.seller.teamLeader.type.name
                ]) /
                100);
            commissionSummary.seller.teamLeader.type.local =
              (commissionSummary.seller.local ?? 0) *
              ((100 -
                CommissionSummary.dataArray[
                  commissionSummary.seller.teamLeader.type.name
                ]) /
                100);
          } else {
            commissionSummary.seller.teamLeader.type.name = 'TEAM_JUNIOR';

            commissionSummary.seller.teamLeader.type.usd =
              (commissionSummary.seller.teamLeader.rawCommission.usd ?? 0) *
              ((100 -
                CommissionSummary.dataArray[
                  commissionSummary.seller.teamLeader.type.name
                ]) /
                100);
            commissionSummary.seller.teamLeader.type.local =
              (commissionSummary.seller.teamLeader.rawCommission.local ?? 0) *
              ((100 -
                CommissionSummary.dataArray[
                  commissionSummary.seller.teamLeader.type.name
                ]) /
                100);
          }

          commissionSummary.seller.teamLeader.agentDeduction.percentage =
            commissionSummary.seller.agent.deduction.percentage;
          commissionSummary.seller.teamLeader.agentDeduction.usd =
            commissionSummary.seller.teamLeader.rawCommission.usd -
            commissionSummary.seller.teamLeader.netCommission.usd -
            commissionSummary.seller.teamLeader.type.usd;
          commissionSummary.seller.teamLeader.agentDeduction.local =
            commissionSummary.seller.teamLeader.rawCommission.local -
            commissionSummary.seller.teamLeader.netCommission.local -
            commissionSummary.seller.teamLeader.type.local;
          commissionSummary.seller.teamLeader.captationOrigin =
            SELLER_TEAM_LEADER_DEDUCTIONS.checkTeamLeader === 1
              ? 'T. Lider'
              : 'T. Member';
        }
      }

      commissionSummary.seller.agent.secondSubtotal.usd =
        commissionSummary.seller.usd -
        commissionSummary.seller.referred.rawCommission.usd -
        commissionSummary.seller.agent.manualDeduction.usd;
      commissionSummary.seller.agent.secondSubtotal.local =
        commissionSummary.seller.local -
        commissionSummary.seller.referred.rawCommission.local -
        commissionSummary.seller.agent.manualDeduction.local;

      if (isSellerMyOffice) {
        commissionSummary.sellerAgentCalculation();

        if (NODE === NODE_DO) {
          commissionSummary.seller.agent.type.name =
            this.organizationCommission.purchaseOrganizationAgentType;
          commissionSummary.seller.agent.type.original =
            AgentTypesArray.agentTypesArray[
              this.organizationCommission.purchaseOrganizationAgentLevelType ??
                ''
            ] ?? '';

          commissionSummary.seller.agent.type.usd =
            (commissionSummary.seller.agent.firstSubtotal.usd ?? 0) *
            ((100 -
              CommissionSummary.dataArray[
                commissionSummary.seller.agent.type.name
              ]) /
              100);
          commissionSummary.seller.agent.type.local =
            (commissionSummary.seller.agent.firstSubtotal.local ?? 0) *
            ((100 -
              CommissionSummary.dataArray[
                commissionSummary.seller.agent.type.name
              ]) /
              100);
        } else {
          commissionSummary.seller.agent.type.name =
            this.organizationCommission.purchaseOrganizationAgentType;
          if (
            this.organizationCommission.purchaseOrganizationId ==
              this.organizationCommission.purchaseOrganizationTeamLeaderId ||
            this.organizationCommission.purchaseOrganizationTeamId
          )
            commissionSummary.seller.agent.type.name = 'TEAM_JUNIOR';

          // Deduccion vendedor por tipo de agente
          commissionSummary.seller.agent.type.usd =
            (commissionSummary.seller.agent.secondSubtotal.usd ?? 0) *
            ((100 -
              CommissionSummary.dataArray[
                commissionSummary.seller.agent.type.name
              ]) /
              100);
          commissionSummary.seller.agent.type.local =
            (commissionSummary.seller.agent.secondSubtotal.local ?? 0) *
            ((100 -
              CommissionSummary.dataArray[
                commissionSummary.seller.agent.type.name
              ]) /
              100);
        }
      }

      // // Envio al componente
      commissionSummary.sellerAgentCalculation();

      // /////////////////////////////////////////////
      // ///////////// Punta Compradora //////////////
      // /////////////////////////////////////////////

      // Relacion
      commissionSummary.buyer.relation = this.saleRelationshipPercentage;

      // USD
      commissionSummary.buyer.usd =
        this.grossComissionUSD * (commissionSummary.buyer.relation / 100);

      // Local
      commissionSummary.buyer.local =
        this.grossComissionARS * (commissionSummary.buyer.relation / 100);

      // Porcentaje
      commissionSummary.buyer.percentage =
        this.organizationCommission.saleCommissionPercentage;

      commissionSummary.buyer.agent.name =
        this.organizationCommission.saleOrganizationName;

      // Deduccion Manual comprador

      const buyerManualDeduction = this.otherDeductions.find(
        (e: OtherDeduction) => e.type == 2,
      );
      if (buyerManualDeduction) {
        commissionSummary.buyer.agent.manualDeduction.name =
          buyerManualDeduction.description;
        commissionSummary.buyer.agent.manualDeduction.usd =
          buyerManualDeduction.amountUSD;
        commissionSummary.buyer.agent.manualDeduction.local =
          buyerManualDeduction.amountARS;
      }

      // Jurisdiccion agente
      commissionSummary.buyer.agent.deduction.percentage =
        this.saleDeduction.deductionPercentage;

      commissionSummary.buyer.agent.deduction.usd =
        this.saleDeduction.deductionAmountUSD;

      commissionSummary.buyer.agent.deduction.local =
        this.saleDeduction.deductionAmountARS;

      // Referido comprador

      const buyerReferredCommission = this.referredCommissions.find(
        (e: ReferredCommission) => e.type == 2,
      );
      // Referido comprador
      const buyerReferredDeduction = this.referredDeductions.find(
        (e: ReferredDeduction) => e.typePayment == 2,
      );
      if (buyerReferredDeduction && buyerReferredCommission) {
        commissionSummary.buyer.referred.name =
          buyerReferredDeduction.organizationName ?? '';
        commissionSummary.buyer.referred.rawCommission.percentage =
          buyerReferredDeduction.deductionPercentage;
        commissionSummary.buyer.referred.rawCommission.usd =
          buyerReferredDeduction.deductionAmountUSD;
        commissionSummary.buyer.referred.rawCommission.local =
          buyerReferredDeduction.deductionAmountARS;
        if (buyerReferredDeduction.organizationId) {
          commissionSummary.buyer.referred.name =
            buyerReferredDeduction.organizationName ?? '';

          if (buyerReferredDeduction.organizationId != 0) {
            if (IS_NODE_DO) {
              commissionSummary.buyer.referred.type.name =
                buyerReferredCommission.organizationAgentType ?? '';
              commissionSummary.buyer.referred.type.original =
                AgentTypesArray.agentTypesArray[
                  buyerReferredCommission.organizationAgentLevelType ?? ''
                ] ?? '';
            } else {
              commissionSummary.buyer.referred.type.name =
                buyerReferredCommission.organizationAgentType;
              if (
                buyerReferredCommission.organizationId ==
                  buyerReferredCommission.organizationTeamLeaderId ||
                buyerReferredCommission.organizationTeamId
              )
                commissionSummary.buyer.referred.type.name = 'TEAM_JUNIOR';
            }

            commissionSummary.buyer.referred.type.usd =
              (commissionSummary.buyer.referred.rawCommission.usd ?? 0) *
              ((100 -
                CommissionSummary.dataArray[
                  commissionSummary.buyer.referred.type.name
                ]) /
                100);
            commissionSummary.buyer.referred.type.local =
              (commissionSummary.buyer.referred.rawCommission.local ?? 0) *
              ((100 -
                CommissionSummary.dataArray[
                  commissionSummary.buyer.referred.type.name
                ]) /
                100);
            commissionSummary.buyer.referred.netCommission.usd =
              buyerReferredCommission.commissionUSD;

            commissionSummary.buyer.referred.netCommission.local =
              buyerReferredCommission.commissionARS;
            switch (commissionSummary.buyer.referred.type.name) {
              case 'ALTO':
                commissionSummary.buyer.referred.agentDeduction.percentage =
                  JURISDICION?.altoDeductionPercentage ?? 0;
                break;
              case 'PURO':
                commissionSummary.buyer.referred.agentDeduction.percentage =
                  JURISDICION?.puroDeductionPercentage ?? 0;
                break;
              case 'TEAM_JUNIOR':
                commissionSummary.buyer.referred.agentDeduction.percentage =
                  JURISDICION?.teamDeductionPercentage ?? 0;
                break;
            }

            commissionSummary.buyer.referred.agentDeduction.local =
              commissionSummary.buyer.referred.rawCommission.local *
              (commissionSummary.buyer.referred.agentDeduction.percentage /
                100);
            commissionSummary.buyer.referred.agentDeduction.usd =
              commissionSummary.buyer.referred.rawCommission.usd *
              (commissionSummary.buyer.referred.agentDeduction.percentage /
                100);
          }
        } else if (
          buyerReferredDeduction.agencyId &&
          (buyerReferredDeduction.organizationType == 1 ||
            buyerReferredDeduction.organizationType == 5)
        ) {
          const office = officeList.find(
            (e: { id: number; name: string }) =>
              e.id == buyerReferredDeduction.agencyId,
          );
          commissionSummary.buyer.referred.officeId = office
            ? office.name.toUpperCase()
            : '-';
        } else {
          commissionSummary.buyer.referred.officeId = '(Otra inmobiliaria)';
        }
      }

      commissionSummary.buyerReferredCalculation();

      // Team Leader Comprador
      if (this.teamLeaderCommissions && this.teamLeaderCommissions.length > 0) {
        const BUYER_TEAM_LEADER_COMMISSION = this.teamLeaderCommissions.find(
          (e: TeamLeaderCommission) => e.type === 2,
        );
        if (BUYER_TEAM_LEADER_COMMISSION) {
          commissionSummary.buyer.teamLeader.name =
            BUYER_TEAM_LEADER_COMMISSION.organizationName;
          commissionSummary.buyer.teamLeader.netCommission.usd =
            BUYER_TEAM_LEADER_COMMISSION.commissionUSD;
          commissionSummary.buyer.teamLeader.netCommission.local =
            BUYER_TEAM_LEADER_COMMISSION.commissionARS;
        }
      }

      if (this.teamLeaderDeductions && this.teamLeaderDeductions.length > 0) {
        const BUYER_TEAM_LEADER_DEDUCTIONS = this.teamLeaderDeductions.find(
          (e: TeamLeaderDeduction) => e.deductionType === 2,
        );
        if (BUYER_TEAM_LEADER_DEDUCTIONS) {
          commissionSummary.buyer.teamLeader.rawCommission.usd =
            BUYER_TEAM_LEADER_DEDUCTIONS.deductionAmountUsd;
          commissionSummary.buyer.teamLeader.rawCommission.local =
            BUYER_TEAM_LEADER_DEDUCTIONS.deductionAmountArs;

          if (NODE === NODE_DO) {
            commissionSummary.buyer.teamLeader.type.name =
              BUYER_TEAM_LEADER_DEDUCTIONS.teamLeaderType ?? '';

            commissionSummary.buyer.teamLeader.type.original =
              AgentTypesArray.agentTypesArray[
                BUYER_TEAM_LEADER_DEDUCTIONS.teamLeaderLevelType ?? ''
              ] ?? '';

            commissionSummary.buyer.teamLeader.type.usd =
              (commissionSummary.buyer.usd ?? 0) *
              ((100 -
                CommissionSummary.dataArray[
                  commissionSummary.buyer.teamLeader.type.name
                ]) /
                100);
            commissionSummary.buyer.teamLeader.type.local =
              (commissionSummary.buyer.local ?? 0) *
              ((100 -
                CommissionSummary.dataArray[
                  commissionSummary.buyer.teamLeader.type.name
                ]) /
                100);
          } else {
            commissionSummary.buyer.teamLeader.type.name = 'TEAM_JUNIOR';

            commissionSummary.buyer.teamLeader.type.usd =
              (commissionSummary.buyer.teamLeader.rawCommission.usd ?? 0) *
              ((100 -
                CommissionSummary.dataArray[
                  commissionSummary.buyer.teamLeader.type.name
                ]) /
                100);
            commissionSummary.buyer.teamLeader.type.local =
              (commissionSummary.buyer.teamLeader.rawCommission.local ?? 0) *
              ((100 -
                CommissionSummary.dataArray[
                  commissionSummary.buyer.teamLeader.type.name
                ]) /
                100);
          }

          commissionSummary.buyer.teamLeader.captationOrigin =
            BUYER_TEAM_LEADER_DEDUCTIONS.checkTeamLeader === 1
              ? 'T. Lider'
              : 'T. Member';

          commissionSummary.buyer.teamLeader.agentDeduction.percentage =
            commissionSummary.buyer.agent.deduction.percentage;
          commissionSummary.buyer.teamLeader.agentDeduction.usd =
            commissionSummary.buyer.teamLeader.rawCommission.usd -
            commissionSummary.buyer.teamLeader.netCommission.usd -
            commissionSummary.buyer.teamLeader.type.usd;
          commissionSummary.buyer.teamLeader.agentDeduction.local =
            commissionSummary.buyer.teamLeader.rawCommission.local -
            commissionSummary.buyer.teamLeader.netCommission.local -
            commissionSummary.buyer.teamLeader.type.local;
        }
      }

      commissionSummary.buyer.agent.secondSubtotal.usd =
        commissionSummary.buyer.usd -
        commissionSummary.buyer.referred.rawCommission.usd -
        commissionSummary.buyer.agent.manualDeduction.usd;
      commissionSummary.buyer.agent.secondSubtotal.local =
        commissionSummary.buyer.local -
        commissionSummary.buyer.referred.rawCommission.local -
        commissionSummary.buyer.agent.manualDeduction.local;

      if (isBuyerMyOffice) {
        commissionSummary.buyerAgentCalculation();

        if (NODE === NODE_DO) {
          commissionSummary.buyer.agent.type.name =
            this.organizationCommission.saleOrganizationAgentType;
          commissionSummary.buyer.agent.type.original =
            AgentTypesArray.agentTypesArray[
              this.organizationCommission.saleOrganizationAgentLevelType ?? ''
            ] ?? '';

          commissionSummary.buyer.agent.type.usd =
            (commissionSummary.buyer.agent.firstSubtotal.usd ?? 0) *
            ((100 -
              CommissionSummary.dataArray[
                commissionSummary.buyer.agent.type.name
              ]) /
              100);
          commissionSummary.buyer.agent.type.local =
            (commissionSummary.buyer.agent.firstSubtotal.local ?? 0) *
            ((100 -
              CommissionSummary.dataArray[
                commissionSummary.buyer.agent.type.name
              ]) /
              100);
        } else {
          commissionSummary.buyer.agent.type.name =
            this.organizationCommission.saleOrganizationAgentType;
          if (
            this.organizationCommission.saleOrganizationId ==
              this.organizationCommission.saleOrganizationTeamLeaderId ||
            this.organizationCommission.saleOrganizationTeamId
          )
            commissionSummary.buyer.agent.type.name = 'TEAM_JUNIOR';

          // Deduccion vendedor por tipo de agente
          commissionSummary.buyer.agent.type.usd =
            (commissionSummary.buyer.agent.secondSubtotal.usd ?? 0) *
            ((100 -
              CommissionSummary.dataArray[
                commissionSummary.buyer.agent.type.name
              ]) /
              100);
          commissionSummary.buyer.agent.type.local =
            (commissionSummary.buyer.agent.secondSubtotal.local ?? 0) *
            ((100 -
              CommissionSummary.dataArray[
                commissionSummary.buyer.agent.type.name
              ]) /
              100);
        }
      }

      // Envio al componente
      commissionSummary.buyerAgentCalculation();
      commissionSummary.officeCalculation();
    }

    // ///////////////////////////////////////////////////////
    // //////////////////// ABAO /////////////////////////////
    // ///////////////////////////////////////////////////////

    if (JURISDICION && this.agentPayments.length > 0) {
      // team leader vendedor
      const officeClientSellerTeamLeader = this.agentPayments.filter(
        (e: AgentPayment) =>
          e.organizationName === commissionSummary.seller.teamLeader.name &&
          e.typePayment === 1,
      );

      const sellerTeamLeaderAbao = this.resolveABAO(
        officeClientSellerTeamLeader,
        commissionSummary.seller.teamLeader.netCommission.local,
        JURISDICION.previsionalCash,
      );
      commissionSummary.seller.teamLeader.abao.usd =
        sellerTeamLeaderAbao.usd ?? 0;
      commissionSummary.seller.teamLeader.abao.local =
        sellerTeamLeaderAbao.local ?? 0;

      // team leader comprador
      const officeClientBuyerTeamLeader = this.agentPayments.filter(
        (e: AgentPayment) =>
          e.organizationName === commissionSummary.buyer.teamLeader.name &&
          e.typePayment === 2,
      );

      const buyerTeamLeaderAbao = this.resolveABAO(
        officeClientBuyerTeamLeader,
        commissionSummary.buyer.teamLeader.netCommission.local,
        JURISDICION.previsionalCash,
      );
      commissionSummary.buyer.teamLeader.abao.usd =
        buyerTeamLeaderAbao.usd ?? 0;
      commissionSummary.buyer.teamLeader.abao.local =
        buyerTeamLeaderAbao.local ?? 0;

      // Referido vendedor
      const officeClientSellerReferred = this.agentPayments.filter(
        (e: AgentPayment) =>
          e.organizationName == commissionSummary.seller.referred.name &&
          e.typePayment == 1,
      );

      const sellerReferredAbao = this.resolveABAO(
        officeClientSellerReferred,
        commissionSummary.seller.referred.netCommission.local,
        JURISDICION.previsionalCash,
      );
      commissionSummary.seller.referred.abao.usd = sellerReferredAbao.usd ?? 0;
      commissionSummary.seller.referred.abao.local =
        sellerReferredAbao.local ?? 0;

      // Referido comprador

      const officeClientBuyerReferred = this.agentPayments.filter(
        (e: AgentPayment) =>
          e.organizationName == commissionSummary.buyer.referred.name &&
          e.typePayment == 2,
      );

      const buyerReferredAbao = this.resolveABAO(
        officeClientBuyerReferred,
        commissionSummary.buyer.referred.netCommission.local,
        JURISDICION.previsionalCash,
      );
      commissionSummary.buyer.referred.abao.usd = buyerReferredAbao.usd ?? 0;
      commissionSummary.buyer.referred.abao.local =
        buyerReferredAbao.local ?? 0;

      // Agente vendedor abao

      const officeClientSellerAgent = this.agentPayments.filter(
        (e: AgentPayment) =>
          e.organizationName == commissionSummary.seller.agent.name &&
          e.typePayment == 1,
      );

      const sellerAgentAbao = this.resolveABAO(
        officeClientSellerAgent,
        commissionSummary.seller.agent.netCommission.local,
        JURISDICION.previsionalCash,
      );
      commissionSummary.seller.agent.abao.usd = sellerAgentAbao.usd ?? 0;
      commissionSummary.seller.agent.abao.local = sellerAgentAbao.local ?? 0;

      // Agente comprador abao

      const officeClientBuyerAgent = this.agentPayments.filter(
        (e: AgentPayment) =>
          e.organizationName == commissionSummary.buyer.agent.name &&
          e.typePayment == 2,
      );

      const buyerAgentAbao = this.resolveABAO(
        officeClientBuyerAgent,
        commissionSummary.buyer.agent.netCommission.local,
        JURISDICION.previsionalCash,
      );
      commissionSummary.buyer.agent.abao.usd = buyerAgentAbao.usd ?? 0;
      commissionSummary.buyer.agent.abao.local = buyerAgentAbao.local ?? 0;
    }
    commissionSummary.sellerTeamLeaderCalculation();
    commissionSummary.buyerTeamLeaderCalculation();
    // ///////////////////////////////////////////////////////
    // //////////////////// FINAL ////////////////////////////
    // ///////////////////////////////////////////////////////

    commissionSummary.officeCalculation();

    const rawOffice =
      commissionSummary.office.rawCommission.usd +
      commissionSummary.office.rawCommission.local / this.exchangeRate;
    const rawOperation =
      commissionSummary.closedPrice.usd +
      commissionSummary.closedPrice.local / (this.exchangeRate ?? 0);

    commissionSummary.office.rawCommission.percentage =
      (rawOffice / rawOperation) * 100;

    commissionSummary.office.subtotal.percentage =
      this.grossAgencyComissionPercentage;

    commissionSummary.sellerAgentCalculation();

    commissionSummary.buyerAgentCalculation();

    commissionSummary.officeCalculation();

    // Pongo las comisiones netas a mano dado que si hay un error en el guardado queremos que se
    // muestre, y no que quede oculto por las cuentas

    // Comision neta vendedor
    commissionSummary.seller.agent.netCommission.usd =
      this.purchaseOrganizationAmountCommissionUSD;
    commissionSummary.seller.agent.netCommission.local =
      this.purchaseOrganizationAmountCommissionARS;

    // Comision neta comprador
    commissionSummary.buyer.agent.netCommission.usd =
      this.saleOrganizationAmountCommissionUSD;
    commissionSummary.buyer.agent.netCommission.local =
      this.saleOrganizationAmountCommissionARS;

    // Comision bruta oficina

    commissionSummary.rawCommission.percentage = this.grossComissionPercentage;
    commissionSummary.rawCommission.usd = this.grossComissionUSD;
    commissionSummary.rawCommission.local = this.grossComissionARS;

    commissionSummary.office.rawCommission.usd = this.grossAgencyComissionUSD;
    commissionSummary.office.rawCommission.local = this.grossAgencyComissionARS;

    commissionSummary.office.rawCommission.percentage =
      this.grossAgencyComissionPercentage;

    commissionSummary.office.subtotal.usd =
      this.grossAgencyComissionUSDWithoutReferredDeduction;
    commissionSummary.office.subtotal.local =
      this.grossAgencyComissionARSWithoutReferredDeduction;

    // Comision neta oficina
    commissionSummary.office.netCommission.usd = this.agencyAmountCommissionUSD;
    commissionSummary.office.netCommission.local =
      this.agencyAmountCommissionARS;

    commissionSummary.iva.office.usd = 0;
    commissionSummary.iva.office.local = 0;
    commissionSummary.iva.agent.usd = 0;
    commissionSummary.iva.agent.local = 0;

    this.billings.forEach((e: Billing) => {
      commissionSummary.iva.office.usd += Number(e.subtotalIVAUSD);
      commissionSummary.iva.office.local += Number(e.subtotalIVAARS);
    });

    this.agentPayments.forEach((e: AgentPayment) => {
      commissionSummary.iva.agent.usd += Number(e.subtotalIVAUSD);
      commissionSummary.iva.agent.local += Number(e.subtotalIVAARS);
    });

    if (commissionSummary.referred.isReferred) {
      // Comision Neta
      commissionSummary.office.rawCommission.usd =
        commissionSummary.closedPrice.usd;
      commissionSummary.office.netCommission.usd =
        commissionSummary.office.rawCommission.usd -
        commissionSummary.referred.netCommission.usd;

      commissionSummary.office.rawCommission.percentage = 100;

      commissionSummary.office.rawCommission.local =
        commissionSummary.closedPrice.local;
      commissionSummary.office.netCommission.local =
        commissionSummary.office.rawCommission.local -
        commissionSummary.referred.netCommission.local;

      commissionSummary.office.subtotal.local =
        commissionSummary.office.netCommission.local;
      commissionSummary.office.subtotal.usd =
        commissionSummary.office.netCommission.usd;
    }
    commissionSummary.officeCalculation();

    // Computo de estadisticas: no aplica a Referido a cobrar ni a Ingreso relacionado.
    // Cada tipo tiene su par borrador: 2/5 referido, 7/8 ingreso relacionado.
    const IS_REFERIDO_A_COBRAR =
      this.renditionType == 2 || this.renditionType == 5;
    const IS_INGRESO_RELACIONADO =
      this.renditionType == 7 || this.renditionType == 8;
    if (IS_NODE_DO && !IS_REFERIDO_A_COBRAR && !IS_INGRESO_RELACIONADO) {
      commissionSummary.statistics = buildStatisticsSummary(
        commissionSummary,
        this.getStatisticsComputationMode(),
        this.exchangeRate ?? 0,
      );
    }

    console.log(commissionSummary);
    return commissionSummary;
  }

  resolveABAO(
    invoices: AgentPayment[],
    capLocal: number,
    percentage: number,
  ): { usd: number; local: number } {
    let restUSD = 0;
    let restLocal = 0;
    let total = 0;

    invoices.forEach((e: AgentPayment) => {
      total =
        total +
        e.subtotalUSD * (percentage / 100) * this.exchangeRate +
        e.subtotalARS * (percentage / 100);
    });

    restLocal = capLocal - total;
    if (restLocal < 0) {
      restUSD = Math.abs(restLocal) / this.exchangeRate;
    }

    return {
      usd: restUSD,
      local: restUSD > 0 ? capLocal : total,
    };
  }
}
export class OtherRealEstate {
  id: number = 0;
  name: string = '';
  visible: boolean = false;
}

export class AgentBilling {
  billDate: null = null;
  billNumber: string = '';
  companyName: string = '';
  concept: string = '';
  organizationId: number = 0;
  organizationName: string = '';
  paymentTypeTxt: null = null;
  subtotalARS: number = 0;
  subtotalIVAARS: number = 0;
  subtotalIVAUSD: number = 0;
  subtotalUSD: number = 0;
  totalARS: number = 0;
  totalUSD: number = 0;
  typePayment: number = 0;
  typePaymentTxt: string = '';
  voucherType: number = 0;
  voucherTypeTxt: string = '';

  formatBEtoFE(): InvoiceRendition {
    return {
      id: 0,
      client:
        this.typePayment == 1
          ? NODE === NODE_DO
            ? 'Captador'
            : 'Vendedor'
          : NODE === NODE_DO
            ? 'Vendedor'
            : 'Comprador',
      agent: this.organizationName,
      number: this.billNumber,
      invoiceType: this.voucherTypeTxt, // Agregar vouchertype
      name: this.companyName,
      description: this.concept,
      amountCurrency: this.subtotalUSD > 0 ? 'USD' : 'Local',
      amount: this.subtotalUSD > 0 ? this.subtotalUSD : this.subtotalARS,
      ivaCurrency: this.subtotalIVAUSD > 0 ? 'USD' : 'Local',
      iva: this.subtotalIVAUSD > 0 ? this.subtotalIVAUSD : this.subtotalIVAARS,
      overbilled: 0,
      origin: 'Agente al cliente',
    } as InvoiceRendition;
  }
}

export class AgentPayment {
  billNumber: string = '';
  bill_number: null = null;
  checkDate: null = null;
  checkNumber: null = null;
  currency: string = '';
  ivaCurrency: string = '';
  organizationId: number = 0;
  organizationName: string = '';
  paymentType: number = 0;
  paymentTypeTxt: string = '';
  renditionId: null = null;
  renditionOperationType: null = null;
  subtotalARS: number = 0;
  subtotalIVAARS: number = 0;
  subtotalIVAUSD: number = 0;
  subtotalUSD: number = 0;
  totalARS: number = 0;
  totalUSD: number = 0;
  typePayment: number = 0;
  typePaymentTxt: string = '';
  voucherType: number = 0;
  voucherTypeEnum: null = null;
  voucherTypeTxt: string = '';

  formatBEtoFE(): InvoiceRendition {
    return {
      agent: this.organizationName,
      id: 0,
      client:
        this.typePayment == 1
          ? NODE === NODE_DO
            ? 'Captador'
            : 'Vendedor'
          : NODE === NODE_DO
            ? 'Vendedor'
            : 'Comprador',
      number: this.billNumber,
      invoiceType: this.voucherTypeTxt, // Agregar vouchertype
      name: '',
      description: '',
      amountCurrency: this.subtotalUSD > 0 ? 'USD' : 'Local',
      amount: this.subtotalUSD > 0 ? this.subtotalUSD : this.subtotalARS,
      ivaCurrency: this.subtotalIVAUSD > 0 ? 'USD' : 'Local',
      iva: this.subtotalIVAUSD > 0 ? this.subtotalIVAUSD : this.subtotalIVAARS,
      overbilled: 0,
      origin: 'Agente a la oficina',
      voucher: this.voucherType,
    } as InvoiceRendition;
  }
}

export class Billing {
  billNumber: string = '';
  checkDate: null = null;
  checkNumber: null = null;
  companyName: string = '';
  concept: string = '';
  currency: string = '';
  ivaCurrency: string = '';
  overbillingLocal: number = 0;
  overbillingUSD: number = 0;
  paymentType: number = 0;
  paymentTypeTxt: string = '';
  subtotalARS: number = 0;
  subtotalIVAARS: number = 0;
  subtotalIVAUSD: number = 0;
  subtotalUSD: number = 0;
  totalARS: number = 0;
  totalUSD: number = 0;
  typePayment: number = 0;
  typePaymentTxt: string = '';
  voucherType: number = 0;
  voucherTypeTxt: string = '';

  formatBEtoFE(): InvoiceRendition {
    return {
      id: 0,
      agent: '',
      client:
        this.typePayment == 1
          ? NODE === NODE_DO
            ? 'Captador'
            : 'Vendedor'
          : NODE === NODE_DO
            ? 'Vendedor'
            : 'Comprador',
      number: this.billNumber,
      invoiceType: this.voucherTypeTxt, // Agregar vouchertype
      name: this.companyName,
      description: this.concept,
      amountCurrency: this.currency == 'USD' ? 'USD' : 'Local',
      amount: this.currency == 'USD' ? this.subtotalUSD : this.subtotalARS,
      ivaCurrency: this.ivaCurrency == 'USD' ? 'USD' : 'Local',
      iva:
        this.ivaCurrency == 'USD' ? this.subtotalIVAUSD : this.subtotalIVAARS,
      overbilled:
        this.currency == 'USD' ? this.overbillingUSD : this.overbillingLocal,
      origin: 'Oficina al cliente',
    } as InvoiceRendition;
  }
}

export class ClientContact {
  purchaseAgentEmail: string = '';
  purchaseAgentTelephone: string = '';
  purchaseClientName: string = '';
  purchaseClientTelephone: string = '';
  purchaseCustomerOrigin: string = '';
  purchaseCustomerOriginId: number = 0;
  purchaseOrganizationId: number = 0;
  purchaseOrganizationName: string = '';
  saleAgentEmail: string = '';
  saleAgentTelephone: string = '';
  saleCustomerOrigin: string = '';
  saleCustomerOriginId: number = 0;
  saleOrganizationId: number = 0;
  saleOrganizationName: null = null;
}

export class Deduction {
  deductionAmountARS: number = 0;
  deductionAmountUSD: number = 0;
  deductionPercentage: number = 0;
}

export class OrganizationCommission {
  purchaseAmountARS: number = 0;
  purchaseAmountUSD: number = 0;
  purchaseCommissionPercentage: number = 0;
  purchaseOrganizationId: number = 0;
  purchaseOrganizationName: string = '';
  purchaseOrganizationType: number = 0;
  purchaseOrganizationAgentType: string = '';
  purchaseOrganizationAgentLevelType?: string | undefined;
  purchaseOrganizationTeamId: number | null = null;
  purchaseOrganizationTeamLeaderId: number | null = null;
  purchaseOtherRemaxOrganizationId: number | null = null;
  saleAmountARS: number = 0;
  saleAmountUSD: number = 0;
  saleCommissionPercentage: number = 0;
  saleOrganizationId: number = 0;
  saleOrganizationName: string = '';
  saleOrganizationType: number = 0;
  saleOrganizationAgentType: string = '';
  saleOrganizationAgentLevelType?: string | undefined;
  saleOrganizationTeamId: number | null = null;
  saleOrganizationTeamLeaderId: number | null = null;
  saleOtherRemaxOrganizationId: number | null = null;
}

export class ReferredCommission {
  commissionARS: number = 0;
  commissionToARS: number = 0;
  commissionUSD: number = 0;
  deductionARS: number = 0;
  deductionUSD: number = 0;
  organizationId: number = 0;
  organizationName: null | string = null;
  organizationAgentType: string = '';
  organizationAgentLevelType: string = '';
  organizationTeamId: number | null = null;
  organizationTeamLeaderId: number | null = null;
  referredDeductionARS: number = 0;
  referredDeductionUSD: number = 0;
  referredOffice: boolean = false;
  type: number = 0;
  typeName: string = '';
}

export class ReferredDeduction {
  agencyId: number = 0;
  deductionAmountARS: number = 0;
  deductionAmountUSD: number = 0;
  deductionPercentage: number = 0;
  organizationId: number = 0;
  organizationIdOtherRemax: number = 0;
  organizationName: string = '';
  organizationType: number = 0;
  referredDeductionARS: number = 0;
  referredDeductionUSD: number = 0;
  typePayment: number = 0;
  typePaymentTxt: string = '';
  organizationNameOtherRemax: string = '';
}
export interface OtherDeduction {
  amountARS: number;
  amountUSD: number;
  description: string;
  percentage: number;
  type: number;
}
export interface Agent {
  agentName: string;
  agentType: string;
  id: number;
  teamId: number | null;
  teamLeaderId: number | null;
}

export interface Jurisdiction {
  id: number;
  iibb: number;
  name: string;
  previsionalCash: number;
  puroDeductionPercentage: number;
  teamDeductionPercentage: number;
  altoDeductionPercentage: number;
}

export interface TeamLeaderDeduction {
  checkTeamLeader: number; // teamLeader = 1, TeamMember = 0
  renditionId: number;
  deductionType: number; // Vendedor = 1 / Comprador = 2
  organizationId: number;
  organizationName: string;
  deductionPercentage: number;
  deductionAmountUsd: number;
  deductionAmountArs: number;
  teamId: number;
  teamLeaderLevelType?: string | undefined;
  teamLeaderType?: string | undefined;
}

export interface TeamLeaderCommission {
  type: number; // Vendedor = 1 / Comprador = 2
  organizationId: number;
  organizationName: string;
  commissionARS: number;
  commissionUSD: number;
}

export class CobrokerTeamLeader {
  checkTeamLeader: 1 | 0;
  renditionId: number;
  deductionType: number;
  organizationName: string;
  organizationId: number;
  teamId: number;
  grossDeductionPercentage: number;
  grossDeductionAmountArs: number;
  grossDeductionAmountUsd: number;
  netDeductionPercentage: number;
  netDeductionAmountArs: number;
  netDeductionAmountUsd: number;
  teamLeaderType: string;
  teamLeaderLevelType: string;
  juniorOrganizationId: number;

  constructor() {
    this.checkTeamLeader = 0;
    this.renditionId = 0;
    this.deductionType = 0;
    this.organizationName = '';
    this.organizationId = 0;
    this.teamId = 0;
    this.grossDeductionPercentage = 0;
    this.grossDeductionAmountArs = 0;
    this.grossDeductionAmountUsd = 0;
    this.netDeductionPercentage = 0;
    this.netDeductionAmountArs = 0;
    this.netDeductionAmountUsd = 0;
    this.juniorOrganizationId = 0;
    this.teamLeaderType = '';
    this.teamLeaderLevelType = '';
  }
}

export class CobrokerCommission {
  type: 1 | 2;
  agencyId: number;
  organizationId: number;
  organizationName: string;
  organizationType: number;
  agentType: string;
  agentLevelType: string;
  grossPercentage: number;
  grossAmountUsd: number;
  netAmountArs: number;
  grossAmountArs: number;
  netPercentage: number;
  netAmountUsd: number;
  organizationIdOtherRemax: number | null;
  organizationNameOtherRemax: string | null;

  constructor() {
    this.type = 1;
    this.agencyId = 0;
    this.organizationId = 0;
    this.organizationName = '';
    this.organizationType = 0;
    this.agentType = '';
    this.agentLevelType = '';
    this.grossPercentage = 0;
    this.grossAmountUsd = 0;
    this.netPercentage = 0;
    this.netAmountUsd = 0;
    this.organizationIdOtherRemax = null;
    this.organizationNameOtherRemax = null;
    this.netAmountArs = 0;
    this.grossAmountArs = 0;
  }
}
